/** Slugs alineados con egresos de caja v1 y seed Supabase. */
export const DEFAULT_EXPENSE_CATEGORY_SLUGS = [
  'supplier_payment',
  'owner_withdrawal',
  'supplies',
  'services',
  'other',
] as const;

export type ExpenseCategorySlug = (typeof DEFAULT_EXPENSE_CATEGORY_SLUGS)[number];

export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategorySlug, string> = {
  supplier_payment: 'Pago a proveedor',
  owner_withdrawal: 'Retiro dueño',
  supplies: 'Insumos',
  services: 'Servicios',
  other: 'Otros',
};

export function isExpenseCategorySlug(value: string): value is ExpenseCategorySlug {
  return (DEFAULT_EXPENSE_CATEGORY_SLUGS as readonly string[]).includes(value);
}

/** Mapeo desde categoría de egreso de caja. */
export function cashOutflowCategoryToExpenseSlug(category: string): ExpenseCategorySlug {
  return isExpenseCategorySlug(category) ? category : 'other';
}
